import { Text, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

export interface InfoItemProps {
  label: string;
  value: string | number;
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  return (
    <Stack
      direction={{ base: 'row', sm: 'column' }}
      space={Spacing['inset.quarck']}
      justifyContent="space-between">
      <Text
        variant={'semibold'}
        fontSize={Typography['fontsize.md']}
        color={isMobile ? 'neutral.black' : 'neutral.dark'}>
        {label}
      </Text>
      <Text
        variant={isMobile ? 'semibold' : 'regular'}
        fontSize={Typography['fontsize.md']}
        color={isMobile ? 'neutral.darkest' : 'neutral.dark'}>
        {value}
      </Text>
    </Stack>
  );
};
